/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventssearchclear2Inputs */

const en_eventssearchclear2 = /** @type {(inputs: Eventssearchclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear search`)
};

const de_eventssearchclear2 = /** @type {(inputs: Eventssearchclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche löschen`)
};

/**
* | output |
* | --- |
* | "Clear search" |
*
* @param {Eventssearchclear2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventssearchclear2 = /** @type {((inputs?: Eventssearchclear2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventssearchclear2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventssearchclear2(inputs)
	return de_eventssearchclear2(inputs)
});
export { eventssearchclear2 as "eventsSearchClear" }